// flow
import React  from 'react';

export type TimePickerProps = {
  onChange?: () => {},
  value?: string | number,
  min?: string,
  max?: string,
  step?: string,
  id?: string,
  name?: string,
  readonly?: string,
  required?: string,
  label?: string,
}

const inputValuePattern = `[0-9]{2}:[0-9]{2}`;

const TimePicker = (props: TimePickerProps) => {
  const {onChange, label, min, max, id, name, step, readonly, required, value} = props;

  const processValue = (value?: string | number) =>{
    if (typeof value === "string" && value.match(inputValuePattern)) {
      return value;
    } else if (typeof value === "number") {
      // in hours, from e.g. 0.333 to 12 h
      if (value < 12) {
        const valueInMinutes = value * 60;
        const hours = `0${Math.floor(valueInMinutes / 60)}`.slice(-2);
        const minutes = `0${valueInMinutes % 60}`.slice(-2);
        return `${hours}:${minutes}`;
      }
      // in minutes, from e.g. 12 to 720
      if (value > 12 && value < 720) {
        const hours = `0${Math.floor(value / 60)}`.slice(-2);
        const minutes = `0${value % 60}`.slice(-2);
        return `${hours}:${minutes}`;
      }
    } else {
      const nowDate = new Date;
      const currentHours = `0${nowDate.getHours()}`.slice(-2);
      const currentMinutes = `0${nowDate.getMinutes()}`.slice(-2);
      return `${currentHours}:${currentMinutes}`;
    }
  }

  return (
    <div className="timepicker-wrapper">
      {label && (
        <label className="timepicker-label" htmlFor={id}>{label}</label>
      )}
      <input
        className="timepicker-input"
        type="time"
        pattern={inputValuePattern} // browser fallback
        onChange={(e: Event) => onChange(e.currentTarget.value)}
        value={processValue(value)}
        id={id}
        min={min}
        max={max}
        name={name}
        step={step}
        disabled={readonly}
        readOnly={readonly}
        required={required}
      />
    </div>
  );
};

export default TimePicker;
